import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./InvoiceList.module.css";
import { fetchNotOnEraInvoiceList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { DatePicker } from "antd";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Api from "../../../utils/Api";
import invoiceIcon from "../../../assets/images/invoice-page-icon.svg";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";

function dateFormatter(cell) {
  if (!cell) {
    return "Not Available";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class NotOnEra extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      dateFrom: "",
      dateTo: "",
      status: "Not an ERA",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      invoiceList: [],
      selectedRow: {},
      isConvertModalOpen: false,
    };
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
       await this.props.fetchNotOnEraInvoiceList(
          this.state.searchKey,
          this.state.sortBy,
          this.state.page
          );
          console.log("aaaa", this.props.invoiceListData)
    if(this.props.invoiceListData && 
      this.props.invoiceListData.exceptionNoEraInvoiceList && 
      this.props.invoiceListData.exceptionNoEraInvoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.exceptionNoEraInvoiceList.invoice
        })
    }
    setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
  }

  callInvoiceListAPI = async() => {
    this.setState({
      invoiceList: []
    })
    
    const payload = this.getPayload();
    await this.props.fetchNotOnEraInvoiceList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      payload
    );
    console.log("this.props.invoiceListData",this.props.invoiceListData)
    if(this.props.invoiceListData && 
      this.props.invoiceListData.exceptionNoEraInvoiceList && 
      this.props.invoiceListData.exceptionNoEraInvoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.exceptionNoEraInvoiceList.invoice
        })
    }

    if(!this.props.invoiceListData.loading){
      this.setState({
        invoiceList: this.props.invoiceListData.exceptionNoEraInvoiceList.invoice
      })
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }

  }

  handleOpenConvertModal = (row) => {
    this.setState((prevState) => ({
      isConvertModalOpen: !prevState.isConvertModalOpen,
      selectedRow: row
    }));
  }


  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <React.Fragment>
        <div>
          {/* <Link title="Edit Invoice" to={{ pathname: `/app/createinvoice/${row.invoice_id}` }}>
            <i class="fa fa-pencil relatedpartylist-edit-icon mr-2"></i>
          </Link>  */}
          {checkIfPermitted(Permissions.VIEW_INVOICE) && (
          <Link title="View Invoice" className="mr-2" to={{ pathname: `/app/invoicedetails/${row.invoice_id}` }}>
            <img src={invoiceIcon} alt="invoice icon" width="15px" />
          </Link>)}
          <Link title="View Claim Details" className="mr-2" to={{ pathname: `/app/claimdetails/${row.mediswitch_transaction_id}` }}>
            <i class="fa fa-eye relatedpartylist-edit-icon"></i>
          </Link>
          {row && (row.response_result_code === "03" || row.response_result_code === "07") &&(<Link title="Convert to Cash Invoice" onClick={()=>this.handleOpenConvertModal(row)}>
            <i class="fa fa-refresh relatedpartylist-edit-icon"></i>
          </Link>)}
        </div>
      </React.Fragment>
    );
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInvoiceListAPI();
    });
  };

      /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
    dateFrom: dateFormatter(this.state.dateFrom),
    dateTo: dateFormatter(this.state.dateTo),
    status: "Not an ERA"
    };
  };
   
  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };

  selectStatus = (event) => {
    let val = event.target.value;
    this.setState(
      {
        status: val,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  }

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div className="text-center">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }
  nameFormatter(cell, row){
    if (!cell && !row.patient_surname) return "Not Available";
    return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)): "") + " " +
    (row.patient_surname ? (row.patient_surname.charAt(0).toUpperCase() + row.patient_surname.slice(1)):""))
  }

  clearFilters = () => {
    this.setState({
      searchKey: "",
      sortBy: "",
      sortName: undefined,
      sortOrder: undefined,
      status: "",
      dateFrom: "",
      dateTo: "",
      page: 1,
      isDataFetched: false
    },()=>{
      this.callInvoiceListAPI();
    });
  }



  onSubmitConvert = async() => {
    this.setState({
      isLoading: true,
    });
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    const payload = {
      "invoice_id": this.state.selectedRow.invoice_id
    }

    try {
      const response = await Api.post("payment/claim/converttocash", payload, {
        headers: headers,
      });
      console.log("response", response);

      this.setState( {
          successMessage: "Converted to Cash Invoice successfully! Redirecting...",
          isLoading: false,
        });

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
          if(response && response.data && response.data.data){
            let data = response.data.data;
            this.props.history.push({
                pathname: "/app/receivepayment",
                state: {
                  patient_id: data.associated_related_party_id,
                  practitioner_id: data.requested_related_party_id,
                  appointment_id: data.appointment_id,
                  conductappointment_id: data.conductappointment_id,
                  invoice_id: this.state.selectedRow.invoice_id,
                  isAppointmentPay: true,
                  amount: data.total
                },
              })
          }
        }, 2000);

       ;


    } catch (error) {
      console.log("Error", error);
      this.setState({
        isLoading: false,
        errorMessage: error && error.response && error.response.data &&
        error.response.data.message
      });
    }
  }

  checkValidData = (data) => {
    if(!data){
       // return "Not Available";
        return "NA";
    }
    return data;
  }

  render() {
    const invoiceList = this.props.invoiceListData && 
    this.props.invoiceListData.exceptionNoEraInvoiceList;

    const mediswitch_result_code_list = this.props.dropdownListData &&
     this.props.dropdownListData.dropdownList && this.props.dropdownListData.dropdownList.mediswitch_result_code_list

     const mediswitch_result_code_list_Options = mediswitch_result_code_list 
     && mediswitch_result_code_list.map((element, index) => (
      <option key={index} value={element.code}>
        {element.status}
      </option>
    ));

    return (
      <div className={style.invoiceListMainWrapper}>
        <div className="row">
          {/* <div className="col-lg-7">
            <h3>Invoice List</h3>
          </div> */}
          <div
                className="col-sm-6 col-md-6 col-lg-3"
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3">
              <select
                    className="form-control"
                    id="appointment_status_id"
                    onChange={this.selectStatus}
                    value={this.state.status}
                  >
                    <option value="">Select Status</option>
                  {mediswitch_result_code_list_Options}
                  </select>
            </div>
            </div>
            <div className="row mb-1 d-flex">
            <div className="col-md-12 order-3 order-md-2 justify-content-md-end">
              <p className={style.clearFilters} onClick={this.clearFilters}>Clear Filters</p>
            </div>
            </div>
            <div className="patient-claim-invoicelist">
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.invoiceList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: invoiceList  && invoiceList.total ? invoiceList.total : 0,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn 
          dataField="invoice_number"
           width="100px" 
           isKey 
           dataSort={true}>
            Invoice No.
          </TableHeaderColumn>
          <TableHeaderColumn 
          dataField="patient_name"  
          width="100px"
          dataFormat={(cell, row)=>this.nameFormatter(cell, row)} 
          dataSort={true}>
           Name
          </TableHeaderColumn>
           <TableHeaderColumn 
          dataField="created_at"  
          width="100px"
          dataFormat={dateFormatter}
          dataSort={true}>
           Invoice Date
          </TableHeaderColumn>
          <TableHeaderColumn dataField="service_start_date" width="110px" dataFormat={dateFormatter} dataSort={true}>
            Service Date
          </TableHeaderColumn>
          <TableHeaderColumn dataField="scheme_name" width="95px" dataFormat={this.checkValidData} dataSort={true}>
            Scheme
          </TableHeaderColumn>
          <TableHeaderColumn 
          dataField="claimed_amount" 
          width="110px"
          dataAlign="right"
           dataFormat={formatNumberToCurrency} 
           dataSort={true}>
            Amount Allocated
          </TableHeaderColumn>
          {/* <TableHeaderColumn dataField="status" width="96px" dataFormat={this.checkValidData} dataSort={true}>
            Status
          </TableHeaderColumn> */}
         <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            dataAlign="center"
            width="80px"
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
        </div>
        <Modal
            isOpen={this.state.isConvertModalOpen}
            toggle={this.handleOpenConvertModal}
            className={style.deleteReason}
            centered
          >
            <ModalHeader
              toggle={this.toggle}
              className={style.deleteReasonHeader}
            >
              Convert to Cash Invoice
            </ModalHeader>
            <ModalBody>
              <div className={style.deleteReasonHeadingWrapper}>
                <p>
                  {" "}
                  Please confirm whether you want to convert this invoice to cash? If yes, then you will be redirected to the receive payment.{" "}
                </p>
              </div>
              <div className={style.deleteReasonFormWrapper}>
                  <div className={`row ${style.deleteBtnWrapper}`}>
                    <div className="col-lg-12">
                      <div>
                        <button
                          type="button"
                          onClick={this.onSubmitConvert}
                          disabled={this.state.successMessage}
                          className={`mr-4 ${style.deleteBtn}`}
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          disabled={this.state.successMessage}
                          className={style.cancelBtn}
                          onClick={this.handleOpenConvertModal}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                  {this.state.isLoading && (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} alt="loader" className={style.loading} />
                  </div>
                  )}
                  {(this.state.successMessage || this.state.errorMessage) && (
                  <div className="row">
                    {this.state.successMessage && (<p className="success-message">
                      {this.state.successMessage}
                    </p>
                    )}
                    {this.state.errorMessage && (<p className="error-message">
                      {this.state.errorMessage}
                    </p>)}
                  </div>
                  )}
              </div>
            </ModalBody>
          </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    console.log("state", state)
  return {
    invoiceListData: state.exceptionNoEraInvoiceList,
    dropdownListData: state.dropdownList, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNotOnEraInvoiceList: (searchKey, sortBy, page, payload) =>
      dispatch(fetchNotOnEraInvoiceList(searchKey, sortBy, page, payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotOnEra);
